import request from '@/utils/request'

// getTransCondList
// export function getTransCondList(param) {
//   let data = param
//   return request({
//     url: `/bidding/epms3020/getTransCondList`,
//     method: 'POST',
//     meta: { apiVersion: '1.0.0' },
//     headers: { 'Content-Type': 'application/json;charset=utf8' },
//     data
//   })
// }
// // getPayCondList
// export function getPayCondList(param) {
//   let data = param
//   return request({
//     url: `/bidding/epms3020/getPayCondList`,
//     method: 'POST',
//     meta: { apiVersion: '1.0.0' },
//     headers: { 'Content-Type': 'application/json;charset=utf8' },
//     data
//   })
// }
// getSubmitDetail
// export function getSubmitDetail(param) {
//   let data = param
//   return request({
//     url: `/bidding/epms3020/getSubmitDetail`,
//     method: 'POST',
//     meta: { apiVersion: '1.0.0' },
//     headers: { 'Content-Type': 'application/json;charset=utf8' },
//     data
//   })
// }
// // getSubmitFile
// export function getSubmitFile(param) {
//   let data = param
//   return request({
//     url: `/bidding/epms3020/getSubmitFile`,
//     method: 'POST',
//     meta: { apiVersion: '1.0.0' },
//     headers: { 'Content-Type': 'application/json;charset=utf8' },
//     data
//   })
// }

// getSubmitFile
export function submitQuot(param) {
  let data = param
  return request({
    url: `/bidding/epms3020/submitQuot`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
